import { useEffect } from "react";
import { useLocation } from "react-router";
import ReactGA from "react-ga4";

const measurementId = import.meta.env.VITE_GA_ANALYTICS_ID;

let initialized = false;

const isAnalyticsEnabled = () => !!measurementId;

export const initAnalytics = () => {
  if (!isAnalyticsEnabled() || initialized) {
    return;
  }
  ReactGA.initialize(measurementId);
  initialized = true;
};

export const trackPageView = (path) => {
  if (!initialized) {
    return;
  }
  ReactGA.send({ hitType: "pageview", page: path });
};

export const trackEvent = (name, params) => {
  if (!initialized) {
    return;
  }
  ReactGA.event(name, params);
};

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);
};
